import { h, render } from 'preact';
import 'preact/debug';

import { preactWidget } from '../../utils';

import widget from './widget-config';
import { LatestNewsComponent } from './component';

export const hydrate = () => {
  const { $root, props } = preactWidget(widget);
  render(<LatestNewsComponent htmlProps={props.htmlProps} widget={widget} $root={$root} />, $root);
};
